<template>
<div>
<p>Thank you for reading this sample. Here are other books you might like.</p><div>
<div id="textcafe-gallery-widget-container"></div>
<script type="application/javascript">
      TextCafeWidget.config({
          'type':'related',
          'id':'9781421425689',
          'coverImageWidth': '30',
          'hideDescriptions': true
      });
      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});
      textCafeGalleryWidget.render();
    </script>
</div>
</div>
</template>
<script>
export default {
  name: 'last',
  data() {
    return {}
    },
      components: {
    }
  }
</script>


// WEBPACK FOOTER //
// last.vue?8acebe1a